import Typography from '@mui/material/Typography';
import subMinutes from 'date-fns/subMinutes';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { useFeePolicy } from 'reservations/account/providers/ConfigProvider';
import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';
import { getDateTime } from 'reservations/base/helpers/getDateTime';
import { getFeeText } from 'reservations/feePolicy/helpers';

export const RequiredPaymentFeeNotice = () => {
  const feePolicy = useFeePolicy();
  const [date, availability] = useWatch({
    name: ['date', 'availability']
  });

  const dateTime = useMemo(
    () => getDateTime(date, availability),
    [date, availability]
  );

  // No availability is only for tests which error out when one is not selected
  // Diners would need to select a time before being able to see this component
  if (!feePolicy.shouldCollect || !availability) {
    return null;
  }

  const cancellationDeadline = subMinutes(
    dateTime,
    feePolicy.cancelDeadlineMinutes
  );

  const perUnit = getFeeText(feePolicy.calcType);

  return (
    <Typography>
      No-shows or cancellations after{' '}
      {COMMON_DATETIME_FORMATS.dayDateAndTime(cancellationDeadline)} are subject
      to a fee of ${feePolicy.fee} {perUnit}.
    </Typography>
  );
};
